module.exports = __webpack_public_path__ + "static/media/Lock-dark.af400cd1.svg";